/* Copyright (c) Trimble Inc. All rights reserved. */

import { useEffect } from "react";
import { useSelector } from "react-redux";
import NotificationService from "../services/NotificationService";
import { useAsyncAction } from "modus/components/form/async-actions/AsyncAction";
import { AsyncActionState } from "modus/components/form/async-actions/AsyncAction.type";
import { MY_SELECTED_TEAM_ } from "header/team-selector/TeamSelector";


export interface INotification {
    requestedBy?: {
        emailAddress: string;
        organization: string;
        accountName?: string;
        name?: string;
        team?: string;
    }
    resource?: any;
    requestDate?: string;
    resourceId: string;
    requestId?: string;
}
export interface NotificationListViewModel {
    asyncResponse?: AsyncActionState<INotification[] | null | undefined>;
  }

export interface NotificationListProps {
    type: 'TEAM'| 'SUBSCRIPTION'| 'CONSENT';
}

/**
 * @name useNotificationListController
 * @description controller to handle TeamList component functionalities and serves model for ApplicationViewer
 * @type Controller
 * @input NotificationListControllerProps
 * @output NotificationListViewModel
 */
export const useNotificationListController = ({type}:NotificationListProps) => {
    const identityEnvironment = useSelector((state: any) => state?.common?.identityEnvironment ?? localStorage.getItem(MY_SELECTED_TEAM_));
    const {state, subscribe} = useAsyncAction(() => NotificationService.getNotifications(type ?? 'TEAM'));
    // Input details
    useEffect(() => {
        if(!subscribe || !type) {
            return
        }

        subscribe();
    }, [subscribe, type]);

    const refreshApprovals = () => {
        subscribe()
    }

    return {
        asyncResponse : state as AsyncActionState<INotification[] | null | undefined>, refreshApprovals
    };;
};
